import React from 'react';
import { Field, CccisdInput, CccisdToggle } from 'cccisd-formik';
import { BuilderBlock, reportTemplateBuilder } from 'cccisd-laravel-appdefs';
import { startCase } from 'lodash';

export const initialValues = {
    page1: {
        show: true,
        pageNumber: '1',
    },
    page2: {
        show: true,
        pageNumber: '2',
    },
    page3: {
        show: true,
        pageNumber: 'test',
    },
};

const Component = () => {
    let builderBlocks = [];
    for (const valueKey of Object.keys(initialValues)) {
        if (Object.hasOwnProperty.call(initialValues, valueKey)) {
            const dict = initialValues[valueKey];
            let fields = [];

            for (const key of Object.keys(dict)) {
                if (key === 'show') {
                    fields.push(
                        <Field
                            name={valueKey + '.' + key}
                            component={CccisdToggle}
                            label={`Show ${startCase(valueKey)}?`}
                        />
                    );
                    continue;
                }

                fields.push(
                    <Field
                        name={valueKey + '.' + key}
                        component={CccisdInput}
                        label={key.includes('_') ? key.replace('_', '.') : startCase(key)}
                    />
                );
            }
            builderBlocks.push(
                <BuilderBlock title={startCase(valueKey)} key={valueKey}>
                    {fields}
                </BuilderBlock>
            );
        }
    }

    return <>{builderBlocks}</>;
};

export default reportTemplateBuilder({})(Component);
